import { bannerBox } from '../../../components/BannerBox/tokens/bluestone/OP';
import { deprecatedButton } from '../../../deprecated/Button/tokens/bluestone/OP';
import type { ComponentTokens } from '../types';
import { baseComponents } from './base';

export const components: ComponentTokens = {
  ...baseComponents,
  bannerBox,
  deprecatedButton,
};
